<coreui-notification notificationStyle="success" [isPersistent]="false" #successNotification>
  Your changes have been saved.
</coreui-notification>

<coreui-notification notificationStyle="error" [isPersistent]="false" #errorNotification>
  {{ errorNotificationMessage }}
</coreui-notification>

<div class="header">
  <div class="header-content">
    <h1 *ngIf="productType === 'DCDP' && routeName === 'deliveries'">Deliveries</h1>
    <h1 *ngIf="productType === 'DCDP' && routeName === 'audience'">Audience Lists</h1>
    <h1 *ngIf="productType === 'DCDP' && routeName === 'definition'">Audience Definitions</h1>

    <div class="header-right">
      <div
        *ngIf="(disableGoToBuilder$ | async) === false && productType !== 'DCDP' && featureAccessService.hasAccess(definitionWriteAction)">
        <button coreUIButton withIcon="left" (click)="goToBuilder()" [disabled]="disableGoToBuilder$ | async">
          <i coreUIIcon="plus"></i>New Audience Definition
        </button>
      </div>
      <div
        *ngIf="(disableGoToBuilder$ | async) === false && productType === 'DCDP' && featureAccessService.hasAccess(definitionWriteAction) && routeName === 'definition'"
        class="button-right">
        <div *ngIf="isAudienceAI">
          <coreui-menu buttonLabel="New Definition" menuButtonStyle="button" buttonType="primary"
            [disabled]="disableGoToBuilder$ | async" verticalPosition="bottom" menuAlignment="right"
            panelCssClass="core-menu">
      
            <coreui-menu-section>
              <coreui-card class="card" role="button" borderStyle="solidSecondary" tabindex="0" (click)="goToBuilder()">
                <div class="card-content">
                  <div class="icon"><i coreUIIcon="browser"></i></div>
                  <div class="content">
                    <h3>Visual Builder</h3>
                    <span class="text-style-muted-1">
                      Easily create your perfect audience with our visual builder. Start crafting precise, effective
                      audiences in just a few clicks.
                    </span>
                  </div>
                </div>
              </coreui-card>
      
              <coreui-card class="card" role="button" backgroundColor="secondary" borderStyle="solidSecondary" tabindex="0"
                (click)="goToAudienceAIChatDailog()">
                <div class="card-content">
                  <div class="icon"><i coreUIIcon="wand"></i></div>
                  <div class="content">
                    <div class="audience-tag">
                      <h3>Audience AI</h3>
                      <div class="beta-tag text-style-4">BETA</div>
                    </div>
                    <span class="text-style-muted-1">
                      Discover and target your ideal audience with AI-driven insights. Build smarter, more effective
                      audiences effortlessly.
                    </span>
                  </div>
                </div>
              </coreui-card>
            </coreui-menu-section>
          </coreui-menu>
        </div>
        <div *ngIf="!isAudienceAI">
          <button coreUIButton withIcon="left" (click)="goToBuilder()" [disabled]="disableGoToBuilder$ | async">
            <i coreUIIcon="plus"></i>New Definition
          </button>
        </div>
      </div>
      <div *ngIf="(disableGoToBuilder$ | async) === true && featureAccessService.hasAccess(definitionWriteAction)"
        coreUITooltip="Select a data universe to build an audience definition">
        <button coreUIButton withIcon="left">
          <i coreUIIcon="plus"></i>New Audience Definition
        </button>
      </div>
      <coreui-select *ngIf="dataUniverses?.length && productType !== 'DCDP'"
        (valueChange)="onDataUniverseSelect($event)" [value]="activeDataUniverse">
        <coreui-option *ngFor="let dataUniverse of dataUniverses" [value]="dataUniverse">
          {{ dataUniverse.displayName }}
        </coreui-option>
      </coreui-select>
    </div>
  </div>

  <div *ngIf="productType" class="tabs" [style.display]="productType !== 'DCDP' ? 'block' : 'none' "  [ngClass]="{'disableAction': isTabsDataLoading}">
    <coreui-tab-group (tabChange)="tabChange($event)">
      <coreui-tab label="Audience Definition" *ngIf="productType !== 'DCDP' && productType !== 'EPCP'"
        [active]="tableFilterService.tableType$.value === 'definition'"></coreui-tab>
      <coreui-tab label="Audience List" *ngIf="productType !== 'DCDP' && productType !== 'EPCP'"
        [active]="tableFilterService.tableType$.value === 'audience'"></coreui-tab>
      <coreui-tab *ngIf="productType !== 'DCDP' && productType !== 'EPCP'" label="Monitor"
        [active]="tableFilterService.tableType$.value === 'monitor'"></coreui-tab>
    </coreui-tab-group>
  </div>
</div>

<lib-overview-table></lib-overview-table>